import { convertForBackend } from 'c1-i18n'
import {
  LOGIN_SUCCESS,
  LOGIN_TENANT_SELECT,
  LOGIN_FAILURE,
  SET_AUTH_LOCATION,
  SHOW_SYS_CONFIG,
  SINGLE_SIGN_ON_FAILURE,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAILURE,
  SYS_CONFIG_STATUS_CODE,
  SET_WFM_MENU_ITEMS,
  SET_FR_SESSION_INITIALIZED,
  SET_FORGEROCK_ID_TOKEN,
  SET_FR_LOGIN_URL,
  SET_FR_CLIENT_ID,
  SET_FR_OP_URL,
  SET_FR_REALM,
  SET_WAS_AUTH_FR,
  SET_AUTH_CONFIG,
  AuthenticationSource,
} from './login.constants'
import * as api from './login.api'
import { setLoading, setReady, getDxStatus, getFRDxStatus, getDxUserAccess, getTeleoptiConfig, getTheme, setInitialRoute } from '../app.actions'
import { getAlerts } from '../Alerts/alerts.actions'
import { useFRSessionCheck } from '../../Common/useFRSessionCheck/useFRSessionCheck'
import jwt_decode from 'jwt-decode'
import { BI_PERMISSION_SET } from '../../Permissions/permissions.constants'
import { c1RelativeUrlToSpaRoute } from '../../Permissions/RootRoute'
import { batch } from 'react-redux'
import { datadogRum } from '@datadog/browser-rum'

export const loginSuccess = user => ({
  type: LOGIN_SUCCESS,
  user,
})

export const loginTenantSelect = tenants => ({
  type: LOGIN_TENANT_SELECT,
  tenants,
})

export const loginFailure = error => ({
  type: LOGIN_FAILURE,
  error,
})

export const showSysConfig = show => ({ type: SHOW_SYS_CONFIG, show })

export const singleSignOnFailure = error => ({
  type: SINGLE_SIGN_ON_FAILURE,
  error,
})

export const logoutSuccess = user => ({
  type: LOGOUT_SUCCESS,
  user,
})

export const logoutFailure = error => ({
  type: LOGOUT_FAILURE,
  error,
})

export const sendEmailSuccess = result => ({
  type: SEND_EMAIL_SUCCESS,
  result,
})

export const sendEmailFailure = error => ({
  type: SEND_EMAIL_FAILURE,
  error,
})
export const setWfmMenuItems = menuItems => ({
  type: SET_WFM_MENU_ITEMS,
  menuItems,
})

export const setFRSessionInitialized = isFRSessionInitialized => ({
  type: SET_FR_SESSION_INITIALIZED,
  isFRSessionInitialized,
})

export const setAuthLocation = authLocation => ({ type: SET_AUTH_LOCATION, authLocation })
export const setforgerockIdToken = forgerockIdToken => ({ type: SET_FORGEROCK_ID_TOKEN, forgerockIdToken })
export const setfrLoginUrl = frLoginUrl => ({ type: SET_FR_LOGIN_URL, frLoginUrl })
export const setfrClientId = frClientId => ({ type: SET_FR_CLIENT_ID, frClientId })
export const setfrOpUrl = frOpUrl => ({ type: SET_FR_OP_URL, frOpUrl })
export const setfrRealm = frRealm => ({ type: SET_FR_REALM, frRealm })
export const setWasAuthFR = wasAuthFR => ({ type: SET_WAS_AUTH_FR, wasAuthFR })
export const setAuthConfig = authConfig => ({ type: SET_AUTH_CONFIG, authConfig })

const invalidSessionHandler = (dispatch, forgerockIdToken, frLoginUrl, frOpUrl, frRealm, wasAuthFR) => async () => {
  if (globalSessionCheck) {
    globalSessionCheck.destroy()
    globalSessionCheck = null
    globalRemoveSessionCheckEventHandlers()
    globalRemoveSessionCheckEventHandlers = null
  }
  dispatch(logoutSuccess(null))
  await api.logoutApi(forgerockIdToken, frLoginUrl, frOpUrl, frRealm, wasAuthFR)
}

export const isTokenValid = forgerockIdToken => {
  try {
    const decodedForgerockIdToken = jwt_decode(forgerockIdToken)
    const expireEpoch = decodedForgerockIdToken.exp
    const expireDate = new Date(0)
    expireDate.setUTCSeconds(expireEpoch)
    const currentDate = new Date()
    return currentDate < expireDate
  } catch (e) {
    return false
  }
}

const generateDxStatusConfig = forgerockIdToken => {
  return forgerockIdToken
    ? { headers: { Authorization: `Bearer ${forgerockIdToken}` } }
    : {}
}

const getSessionClaimsHandlerNullTokenCheck = function getSessionClaimsHandlerNullTokenCheck(authLocation, legacyAuthResponse, forgerockIdToken) {
  const decodedForgerockIdToken = forgerockIdToken ? jwt_decode(forgerockIdToken) : {}

  return async function sessionClaimsHandler(newClaims) {
    // First, the appTenant.c1.url should match our current url (e.g. this token is intended for this C1 deployment).
    const appTenantUrl = newClaims?.appTenant?.c1?.url
    const appTenantId = newClaims?.appTenant?.c1?.id
    const c1TenantId = legacyAuthResponse?.data?.tenantId

    if (appTenantUrl !== window.location.origin && process.env.NODE_ENV !== 'development') {
      this.invalidSessionHandler()
    }
    // Second, the appTenant.c1.id should match the tenant id of the current user's session.
    if (appTenantId !== c1TenantId) {
      this.invalidSessionHandler()
    }

    if (!decodedForgerockIdToken.sub && newClaims) {
      window.location.href = authLocation
      await new Promise(() => { /* Return a blank promise so that execution pauses while we wait for the window change */ })
    }
    // else if (
    //   newClaims.auth_time !== decodedForgerockIdToken.auth_time ||
    //     decodedForgerockIdToken.realm !== newClaims.realm
    // ) {
    //   this.invalidSessionHandler()
    // }
  }
}

/**
 * Add all BI related permissions in globalUser
 * to legacyAuthResponse
 */
export const reconcileDXPermissions = function reconcileDXPermissions(legacyAuthResponse, globalUser) {
  globalUser && globalUser.permissions && globalUser.permissions.forEach(permission => {
    /* If a permission is one of BI_PERMISSION_SET and is not in LegacyAuthResponse */
    if (BI_PERMISSION_SET.has(permission)
      && legacyAuthResponse.permissions.indexOf(permission) === -1) {
      legacyAuthResponse.permissions.push(permission)
    }
  })

  return legacyAuthResponse
}

const doLegacyPostAuthorizeActions = legacyAuthResponse => async dispatch => {
  batch(() => {
    dispatch(loginSuccess(legacyAuthResponse))
    dispatch(getAlerts())
    dispatch(getDxStatus())
  })

  if (legacyAuthResponse.tenantId !== -1) {
    batch(() => {
      dispatch(getTeleoptiConfig(legacyAuthResponse.tenantId))
      dispatch(getDxUserAccess())
    })
  }
  await dispatch(getTheme())
}
const doPostAuthorizeActions = (legacyAuthResponse, forgerockIdToken, dxStatusConfig) => async dispatch => {
  const gatewayUrl = await api.getGatewayUrl()
  const twfmMenuItems = await api.getWfmConfigFromApiGateway(gatewayUrl, forgerockIdToken)
  const currentGlobalUser = await api.getCurrentGlobalUser(gatewayUrl, forgerockIdToken)
  const reconciledLegacyAuthResponse = reconcileDXPermissions(legacyAuthResponse, currentGlobalUser)
  batch(() => {
    dispatch(setWfmMenuItems(twfmMenuItems))
    dispatch(loginSuccess(reconciledLegacyAuthResponse))
    dispatch(getAlerts())
    dispatch(getFRDxStatus(dxStatusConfig))
  })
  if (reconciledLegacyAuthResponse.tenantId !== -1) {
    batch(() => {
      dispatch(getTeleoptiConfig(reconciledLegacyAuthResponse.tenantId))
      dispatch(getDxUserAccess())
    })
  }
  await dispatch(getTheme())
}

let globalSessionCheck
let globalRemoveSessionCheckEventHandlers

export const tryAuthenticate = forgerockIdToken => async dispatch => {
  if (globalSessionCheck) {
    globalSessionCheck.destroy()
    globalSessionCheck = null
    globalRemoveSessionCheckEventHandlers()
    globalRemoveSessionCheckEventHandlers = null
  }
  try {
    batch(() => {
      dispatch(setReady(false))
      dispatch(setLoading(true))
    })

    // Forgerock must be passed a redirect uri for development purposes
    // if this is not passed, then you will be redirected to the machine you are proxying to
    const devParams = { redirectUri: location.origin }

    const authLocationResponse = await api.getFRAuthLocation(devParams)
    batch(() => {
      dispatch(setAuthLocation(authLocationResponse.data.authLocation))
      dispatch(setfrLoginUrl(authLocationResponse.data.forgerockLoginUrl))
      dispatch(setfrClientId(authLocationResponse.data.forgerockClientId))
      dispatch(setfrOpUrl(authLocationResponse.data.forgerockHost))
      dispatch(setfrRealm(authLocationResponse.data.forgerockRealm))
    })

    const authLocation = authLocationResponse.data.authLocation
    const forgerockLoginUrl = authLocationResponse.data.forgerockLoginUrl
    const forgerockOpUrl = authLocationResponse.data.forgerockHost
    const forgerockRealm = authLocationResponse.data.forgerockRealm
    const forgerockClientId = authLocationResponse.data.forgerockClientId
    const isFR = authLocationResponse.data.authLocation !== null

    const isIamRedirect = sessionStorage.getItem('iamRedirect') === 'true'
    // Remove the IAM redirect flag from sessionStorage to prevent infinite redirects if something goes wrong.
    sessionStorage.removeItem('iamRedirect')

    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    if (code) {
      const forgerockIdTokenResp = await api.tryAuthenticateFR(code, devParams, forgerockLoginUrl)
      dispatch(setforgerockIdToken(forgerockIdTokenResp.data.id_token))
      forgerockIdToken = forgerockIdTokenResp.data.id_token

      const state = urlParams.get('state')
      if (state) {
        try {
          const decodedState = atob(state)
          const initialRoute = c1RelativeUrlToSpaRoute(window.location.origin, decodedState)
          dispatch(setInitialRoute(initialRoute))
        } catch (e) {
          // Handle any error that could occur while determining the initial route. The fallback is not to have an initial route which
          // should result in the default route being used.
          // eslint-disable-next-line no-console -- log a message to help with any troubleshooting that might be needed.
          console.error('Error occurred while determining the initial route.')
        }
      }
    }

    let legacyAuthResponse
    try {
      // Check for IDP param on page load so we can send the user directly to IDP if navigating with a link
      const hashParams = new URLSearchParams(window.location.hash.split('?')[1])
      const idp = urlParams.get('idp') || hashParams.get('idp')
      if (idp) {
        legacyAuthResponse = await api.singleSignOnOnPageLoad(idp)
      } else {
        legacyAuthResponse = await api.tryAuthenticateOnPrem()
      }
    } catch (e) {
      legacyAuthResponse = { status: 401 }
    }

    if (legacyAuthResponse.status === 200) {
      if (legacyAuthResponse.data?.authenticationSource === AuthenticationSource.IAM_AUTHENTICATION && legacyAuthResponse.data?.subdomainUrl?.trim()) {
        sessionStorage.setItem('subDomainLoginUrl', legacyAuthResponse.data.subdomainUrl)
      }

      // if its a 200 then determine what type of session it was
      const wasAuthFR = legacyAuthResponse.data.authenticationMethod === 'fr'
      const authConfig = await api.getAuthConfig()
      batch(() => {
        dispatch(setWasAuthFR(wasAuthFR))
        dispatch(setAuthConfig(authConfig))
      })
      window.localStorage.setItem('wasAuthFR', wasAuthFR)
      if (wasAuthFR) {
        if (isTokenValid(forgerockIdToken)) {
          const dxStatusConfig = generateDxStatusConfig(forgerockIdToken)
          const { removeSessionCheckEventHandlers, sessionCheck } =
          useFRSessionCheck(
            invalidSessionHandler(dispatch, forgerockIdToken, forgerockLoginUrl, forgerockOpUrl, forgerockRealm, wasAuthFR),
            getSessionClaimsHandlerNullTokenCheck(authLocation, legacyAuthResponse, forgerockIdToken),
            forgerockIdToken,
            forgerockOpUrl,
            forgerockClientId,
            forgerockRealm,
          )
          globalSessionCheck = sessionCheck
          globalRemoveSessionCheckEventHandlers = removeSessionCheckEventHandlers
          await dispatch(doPostAuthorizeActions(legacyAuthResponse.data, forgerockIdToken, dxStatusConfig))
        } else {
          forgerockIdToken ?
            await api.logoutApi('reAuth', forgerockLoginUrl, forgerockOpUrl, forgerockRealm, wasAuthFR) :
            await api.logoutApi('', forgerockLoginUrl, forgerockOpUrl, forgerockRealm, wasAuthFR)
          dispatch(logoutSuccess(null))
        }
      } else {
        // This means the session is completely legacy
        await dispatch(doLegacyPostAuthorizeActions(legacyAuthResponse.data))
      }
    } else if (legacyAuthResponse.status === 401) {
      if (isFR && isIamRedirect) {
        // eslint-disable-next-line no-console -- log a message to help with any troubleshooting that might be needed as any other detail about how the user got here is removed.
        console.log('Redirecting to IAM with state for authentication.')
        api.removeLocalStorageItems()
        const encodedPath = btoa(window.location.href)
        window.location.href = authLocation + '&state=' + encodedPath + '&redirect_to_aic=true'
        await new Promise(() => { /* Return a blank promise so that execution pauses while we wait for the window change */ })
      } else if (isFR && forgerockIdToken) {
        await api.logoutApi('reAuth', forgerockLoginUrl, forgerockOpUrl, forgerockRealm, true)
      } else {
        api.removeLocalStorageItems()
        dispatch(logoutSuccess(null))
      }
    } else if (legacyAuthResponse.status === 278) { // 278 is used for SSO. When this happens then we want to redirect to the location header that is sent from the backend.
      window.location.href = legacyAuthResponse.headers.location
    } else {
      // This is for the neither case, may not need e.g. dont get a 200 or a 401 from /authorize
    }

  } catch (e) {
    if (e.response && e.response.status && e.response.status === SYS_CONFIG_STATUS_CODE) {
      dispatch(showSysConfig(true))
    }
  } finally {
    batch(() => {
      dispatch(setLoading(false))
      dispatch(setReady(true))
    })
  }
}

export const login = (username, password, tenant, locale) => {
  return async dispatch => {
    try {
      const convertedLocale = convertForBackend(locale)
      dispatch(setLoading(true))
      const res = await api.login(username, password, tenant, convertedLocale)
      if (res.tenants) {
        dispatch(loginTenantSelect(res.tenants))
      } else {
        window.location.reload()
        batch(() => {
          dispatch(setReady(false))
          dispatch(loginSuccess(res.user))
          dispatch(getAlerts())
          dispatch(getDxStatus(res.user.sessionId))
          dispatch(getDxUserAccess())
        })
        if (res.user.tenantId !== -1) {
          batch(() => {
            dispatch(getTeleoptiConfig(res.user.tenantId))
            dispatch(getDxUserAccess())
          })
        }
        await dispatch(getTheme())
      }
    } catch (e) {
      dispatch(loginFailure(e))
    } finally {
      batch(() => {
        dispatch(setLoading(false))
        dispatch(setReady(true))
      })
    }
  }
}

export const singleSignOn = (username, tenant) => {
  return async dispatch => {
    try {
      dispatch(setLoading(true))
      const res = await api.singleSignOn(username, tenant)
      if (res.tenants) {
        dispatch(loginTenantSelect(res.tenants))
      } else {
        //This won't be reached because of the redirect
        batch(() => {
          dispatch(loginSuccess(res.user))
          dispatch(getAlerts())
          dispatch(getDxStatus(res.user.sessionId))
        })

        if (res.user.tenantId !== -1) {
          batch(() => {
            dispatch(getTeleoptiConfig(res.user.tenantId))
            dispatch(getDxUserAccess())
          })
        }
        dispatch(getTheme())
      }
    } catch (e) {
      dispatch(singleSignOnFailure(e))
    } finally {
      dispatch(setLoading(false))
    }
  }
}

export const logout = (forgerockIdToken, frLoginUrl, frOpUrl, frRealm, wasAuthFR) => {
  return async dispatch => {
    if (globalSessionCheck) {
      globalSessionCheck.destroy()
      globalSessionCheck = null
      globalRemoveSessionCheckEventHandlers()
      globalRemoveSessionCheckEventHandlers = null
    }
    try {
      dispatch(setLoading(true))
      await api.logoutDx()
      await api.logoutApi(forgerockIdToken, frLoginUrl, frOpUrl, frRealm, wasAuthFR)
      dispatch(logoutSuccess(null))

      // Log successful logout to Datadog
      datadogRum.addAction('Logout successful')
    } catch (e) {
      // Log logout failure to Datadog
      datadogRum.addError(e)

      dispatch(logoutFailure(e))
    } finally {
      if (!wasAuthFR && !window.location.href.includes('resetPassword')) {
        window.history.replaceState({}, null, window.location.origin)
      }
      dispatch(setLoading(false))
    }
  }
}

export const sendForgotPasswordEmail = email => {
  return async dispatch => {
    try {
      const result = await api.sendPasswordResetEmail(email)
      dispatch(sendEmailSuccess(result))
      return result
    } catch (e) {
      dispatch(sendEmailFailure(e))
      return e
    }
  }
}
